import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12373bf4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "d-flex align-items-center my-1" }
const _hoisted_5 = { class: "d-flex align-items-center position-relative w-250px" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-1 position-absolute ms-6" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      opacity: "0.5",
      x: "17.0365",
      y: "15.1223",
      width: "8.15546",
      height: "2",
      rx: "1",
      transform: "rotate(45 17.0365 15.1223)",
      fill: "currentColor"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z",
      fill: "currentColor"
    })
  ])
], -1))
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = { class: "d-flex align-items-center position-relative w-250px ms-5" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-1 position-absolute ms-6" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      opacity: "0.5",
      x: "17.0365",
      y: "15.1223",
      width: "8.15546",
      height: "2",
      rx: "1",
      transform: "rotate(45 17.0365 15.1223)",
      fill: "currentColor"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z",
      fill: "currentColor"
    })
  ])
], -1))
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = { value: "" }
const _hoisted_12 = { value: "pending" }
const _hoisted_13 = { value: "waiting_for_deliver" }
const _hoisted_14 = { value: "recycle" }
const _hoisted_15 = { value: "opened" }
const _hoisted_16 = { value: "delivered" }
const _hoisted_17 = { value: "abandoned" }
const _hoisted_18 = { value: "compounded" }
const _hoisted_19 = { class: "card-body py-4" }
const _hoisted_20 = {
  key: 0,
  class: "position-absolute w-100 h-100 top-0 start-0 bg-white bg-opacity-50 d-flex align-items-center justify-content-center",
  style: {"z-index":"100"}
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = { class: "table-responsive" }
const _hoisted_24 = { class: "table align-middle table-row-dashed fs-6 gy-5" }
const _hoisted_25 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_26 = { class: "text-gray-600 fw-semibold" }
const _hoisted_27 = { class: "d-flex justify-content-end py-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vxe_pager = _resolveComponent("vxe-pager")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control form-control-solid ps-15",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.product_name) = $event)),
              placeholder: _ctx.$t('search_product')
            }, null, 8, _hoisted_7), [
              [_vModelText, _ctx.product_name]
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control form-control-solid ps-15",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.mobile) = $event)),
              placeholder: _ctx.$t('search_user_mobile')
            }, null, 8, _hoisted_10), [
              [_vModelText, _ctx.mobile]
            ])
          ]),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.status) = $event)),
            class: "form-select form-select-solid w-150px ms-5"
          }, [
            _createElementVNode("option", _hoisted_11, _toDisplayString(_ctx.$t('all_status')), 1),
            _createElementVNode("option", _hoisted_12, _toDisplayString(_ctx.$t('pending')), 1),
            _createElementVNode("option", _hoisted_13, _toDisplayString(_ctx.$t('waiting_for_deliver')), 1),
            _createElementVNode("option", _hoisted_14, _toDisplayString(_ctx.$t('recycle')), 1),
            _createElementVNode("option", _hoisted_15, _toDisplayString(_ctx.$t('opened')), 1),
            _createElementVNode("option", _hoisted_16, _toDisplayString(_ctx.$t('delivered')), 1),
            _createElementVNode("option", _hoisted_17, _toDisplayString(_ctx.$t('abandoned')), 1),
            _createElementVNode("option", _hoisted_18, _toDisplayString(_ctx.$t('compounded')), 1)
          ], 512), [
            [_vModelSelect, _ctx.status]
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary ms-5",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleSearch && _ctx.handleSearch(...args)))
          }, _toDisplayString(_ctx.$t('search')), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_22))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("table", _hoisted_24, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", _hoisted_25, [
              _createElementVNode("th", null, _toDisplayString(_ctx.$t('user_nickname')), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t('user_mobile')), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t('product_name')), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t('product_recycle_price')), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t('count')), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t('status')), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t('created_at')), 1)
            ])
          ]),
          _createElementVNode("tbody", _hoisted_26, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: item.product_name + item.user_mobile
              }, [
                _createElementVNode("td", null, _toDisplayString(item.user_nickname), 1),
                _createElementVNode("td", null, _toDisplayString(item.user_mobile), 1),
                _createElementVNode("td", null, _toDisplayString(item.product_name), 1),
                _createElementVNode("td", null, _toDisplayString(_ctx.formatPrice(item.product_recycle_price)), 1),
                _createElementVNode("td", null, _toDisplayString(item.count), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("span", {
                    class: _normalizeClass(_ctx.getStatusClass(item.status))
                  }, _toDisplayString(_ctx.$t(item.status)), 3)
                ]),
                _createElementVNode("td", null, _toDisplayString(item.created_at), 1)
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_27, [
        _createVNode(_component_vxe_pager, {
          "current-page": _ctx.page.currentPage,
          "onUpdate:current-page": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.page.currentPage) = $event)),
          "page-size": _ctx.page.pageSize,
          "onUpdate:page-size": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.page.pageSize) = $event)),
          total: _ctx.page.totalResult,
          layouts: [
            'PrevJump',
            'PrevPage',
            'Number',
            'NextPage',
            'NextJump',
            'Sizes',
            'FullJump',
            'Total',
          ],
          onPageChange: _ctx.onPageChange
        }, null, 8, ["current-page", "page-size", "total", "onPageChange"])
      ])
    ])
  ]))
}